import * as React from "react"
import ReferencePage from "../components/reference-page/reference-page"
import { OfficeDepot } from "../interfaces/reference/references/office-depot-reference"

const OfficeDepotPage = () => {
  return <ReferencePage reference={OfficeDepot} exclude={'od'}/>
}

export default OfficeDepotPage
